import { createFileRoute } from '@tanstack/react-router';
import { DocumentEditor } from '../../components/editor';

export const Route = createFileRoute('/editor/')({
  component: () => <EditorPage />,
});

function EditorPage() {
  return (
    <div className="h-screen flex flex-col">
      <header className="border-b p-4 bg-background">
        <h1 className="text-2xl font-bold">Document Editor</h1>
        <p className="text-muted-foreground">AFFiNE-like collaborative workspace editor</p>
      </header>
      
      <main className="flex-1 overflow-hidden">
        <DocumentEditor 
          documentId="test-document"
          className="h-full"
        />
      </main>
    </div>
  );
}